var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1957_16895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.40053 19.02C9.12453 19.02 8.93853 19.047 8.84253 19.074V20.841C8.95653 20.868 9.09903 20.8755 9.29553 20.8755C10.014 20.8755 10.4565 20.5125 10.4565 19.899C10.4565 19.35 10.0755 19.02 9.40053 19.02ZM14.631 19.038C14.331 19.038 14.136 19.065 14.0205 19.092V23.007C14.136 23.034 14.322 23.034 14.49 23.034C15.7155 23.043 16.5135 22.368 16.5135 20.94C16.5225 19.695 15.795 19.038 14.631 19.038Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 0H6C5.20435 0 4.44129 0.31607 3.87868 0.87868C3.31607 1.44129 3 2.20435 3 3V27C3 27.7957 3.31607 28.5587 3.87868 29.1213C4.44129 29.6839 5.20435 30 6 30H24C24.7956 30 25.5587 29.6839 26.1213 29.1213C26.6839 28.5587 27 27.7957 27 27V9L18 0ZM11.247 21.285C10.7835 21.72 10.0995 21.915 9.303 21.915C9.14853 21.9179 8.99408 21.9089 8.841 21.888V24.027H7.5V18.123C8.10521 18.033 8.71669 17.9919 9.3285 18C10.164 18 10.758 18.159 11.1585 18.4785C11.5395 18.7815 11.7975 19.278 11.7975 19.863C11.796 20.451 11.601 20.9475 11.247 21.285ZM16.9575 23.3175C16.3275 23.841 15.369 24.09 14.1975 24.09C13.4955 24.09 12.999 24.045 12.6615 24V18.1245C13.2669 18.0365 13.8782 17.9948 14.49 18C15.6255 18 16.3635 18.204 16.9395 18.639C17.562 19.101 17.952 19.8375 17.952 20.895C17.952 22.0395 17.5335 22.83 16.9575 23.3175ZM22.5 19.155H20.202V20.5215H22.35V21.6225H20.202V24.0285H18.843V18.045H22.5V19.155ZM18 10.5H16.5V3L24 10.5H18Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1957_16895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePdf);
export default __webpack_public_path__ + "static/media/file-pdf.0c9837e923249cbf69df04b369035d4c.svg";
export { ForwardRef as ReactComponent };